import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

jQuery( document ).ready( function( $ ) {
  document.querySelectorAll( '.post.swiper' ).forEach( function( el ) {
    var scope  = el.closest( '.block-postslider' ) || el.parentElement;
    var swiper = new Swiper( el, {
      modules:       [ Navigation ],
      slidesPerView: 'auto',
      spaceBetween:  24,
      navigation:    {
        nextEl: scope.querySelector( '.swiper-button-next' ),
        prevEl: scope.querySelector( '.swiper-button-prev' ),
      },
    } );

    // Recalculate slide widths once any deferred-loading slide image
    // resolves, in case a cache or lazy-loader hands them in late.
    el.querySelectorAll( 'img' ).forEach( function( img ) {
      if ( img.complete ) return;
      img.addEventListener( 'load', function() { swiper.update(); }, { once: true } );
    } );
  } );
} );
